import { Box, Typography } from "@mui/material"
import { ErrorOutlined } from "@mui/icons-material"
import { capitalizeFormMessage } from "../helpers/form-message"

import "./style.scss"

interface ErrorProps {
  error: string | null
}

export default function Error({ error }: ErrorProps) {
  if (!error) {
    return null
  }

  return (
    <Box className="components_optimize-error">
      <Box className="error-content">
        <ErrorOutlined className="error-icon" />
        <Typography className="error-message">
          {capitalizeFormMessage(error)}
        </Typography>
      </Box>
    </Box>
  )
}
